import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useLocation, useParams } from 'react-router-dom';
import axios from '../../../api/axios';
import './order-tracking.css'; // Optional for styling
import {
    Col,
    Container,
    Row,
} from "reactstrap";
import { QuotationStatus } from '../../../store/Utility/Status';
import moment from 'moment/moment';
import { useSpinner } from '../../../context/SpinnerContext';

const OrderTracking = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const publicKey = queryParams.get('key');
    const { key } = useParams();
    const [data, setData] = useState(null);
    const { showLoader, hideLoader } = useSpinner();

    const getOrderStatus = async () => {
        showLoader();
        await axios.get(`v1/quotation/order-tracking/${key}`).then(res => {
            var response = res?.data.data;

            if (response.status == QuotationStatus.Completed) {
                response.message = "Your inspection report is ready for your review.";
                response.orderReceived = "active";
                response.orderScheduled = "active";
                response.reportSubmitted = "active";
                response.reportAvailable = "active";
                response.inProgressClass = "active";
            } else if (response.status == QuotationStatus.Inspected || response.status == QuotationStatus.InspectionApproved) {
                response.message = "Inspection report is being reviewed and awaiting approval.";
                response.orderReceived = "active";
                response.orderScheduled = "active";
                response.reportSubmitted = "active";
                response.inProgressClass = "active";
            } else if (response.status == QuotationStatus.Assigned) {
                // if (response.inProgress) {
                //     response.message = "Inspector started to inspect the vehicle";
                //     response.inProgressClass = "active";
                // } else {
                //     response.message = "Inspector assigned to your inspection";
                // }
                response.message = "Inspector assigned to your inspection.";
                response.orderReceived = "active";
                if (response.appointmentDate != null) {
                    response.orderScheduled = "active";
                }
            } else if (response.status == QuotationStatus.Created) {
                response.message = "Your order is received.";
                response.orderReceived = "active";
            }
            else if (response.status == QuotationStatus.Cancelled) {
                response.message = "Your order has been canceled.";
            }
            setData(response);
        }).catch(error => {
            // setErrorMessage(error.response.data.error);
            //  hideLoader();
        });
        hideLoader();
    };

    useEffect(() => {
        getOrderStatus();
    }, []);



    return (
        <div>
            <div className="page-content">
                <section>
                    <Container>
                        <Row className='p-2'>
                            <Col md={3}></Col>
                            <Col md={6} className={`border rounded ${data?.status == QuotationStatus.Cancelled ? 'text-center' : ''}`}>
                                <div className="p-5">
                                    <h3>Track Status of Your Inspection</h3>
                                    {data?.status != QuotationStatus.Cancelled ? <div className="progress-container">
                                        <div className={`step ${data?.orderReceived}`}>
                                            <div className="circle">
                                                <i className="la la-clipboard-check"></i>
                                            </div>
                                            <div className="label">Order Received</div>
                                        </div>
                                        <div className={`step ${data?.orderScheduled}`}>
                                            <div className="circle"> <i className="la la-calendar"></i></div>
                                            <div className="label">Scheduled</div>
                                        </div>
                                        {/* <div className={`step ${data?.inProgressClass}`}>
                                            <div className="circle"> <i className='la la-search'></i></div>
                                            <div className="label">In Progress</div>
                                        </div> */}
                                        <div className={`step ${data?.reportSubmitted}`}>
                                            <div className="circle"><i className='la la-clipboard-list'></i></div>
                                            <div className="label">Completed</div>
                                        </div>
                                        <div className={`step ${data?.reportAvailable}`}>
                                            <div className="circle"><i className='la la-desktop'></i></div>
                                            <div className="label">Report Available</div>
                                        </div>
                                    </div>
                                        :
                                        <div className='row'>
                                            <div><i className='la la-5x text-danger la-times-circle'></i></div>
                                        </div>
                                    }
                                    <div className="status-message">
                                        <p><strong> {data?.message}</strong></p>
                                    </div>
                                    <div className="order-details">
                                        <p>Order Number: <strong> {data?.orderNumber}</strong></p>
                                        <p>Vehicle: <strong>{data?.year} {data?.make} {data?.model}</strong></p>
                                        {data?.status != QuotationStatus.Cancelled && <p>Assigned Inspector: <strong>{data?.assignedInspector != null ? data.assignedInspector : 'Pending assignment'}</strong></p>}
                                        {data?.status != QuotationStatus.Cancelled && <p>Appointment Date: <strong>{data?.appointmentDate != null ? moment(data?.appointmentDate).format('MM.DD.YYYY') : 'To be scheduled'}</strong></p>}
                                    </div>
                                    {data?.status == QuotationStatus.Completed &&
                                        <Row>
                                            <Link className="btn btn-dark" to={`/report/${data?.id}`}>View Report</Link>
                                        </Row>
                                    }
                                    {data?.status < QuotationStatus.Completed && <span style={{ fontStyle: "italic", fontSize: "14px" }}>* The appointment date shown is estimated and subject to change.</span>}
                                </div>
                            </Col>
                            <Col md={3}></Col>
                        </Row>
                    </Container>
                </section>
            </div>
        </div>
    );
};

export default OrderTracking;
